export default {
  root: ({ props }) => ({
    class: [
      //Font
      'text-xs font-bold',

      //Alignments
      'inline-flex items-center justify-center',

      //Spacing
      'px-2 py-1',

      //Shape
      {
        'rounded-md': !props.rounded,
        'rounded-full': props.rounded
      },

      //Colors
      'text-white dark:text-secondary-900',
      {
        'bg-primary-500 dark:bg-primary-400': props.severity == null || props.severity == 'primary',
        'bg-green-500 dark:bg-green-400': props.severity == 'success',
        'bg-info-500 dark:bg-info-400': props.severity == 'info',
        'bg-warning-500 dark:bg-warning-400': props.severity == 'warning',
        'bg-danger-500 dark:bg-danger-400': props.severity == 'danger'
      }
    ]
  }),
  value: {
    class: 'leading-normal'
  },
  icon: {
    class: 'mr-1 text-sm'
  }
};
